export default __webpack_public_path__ + "static/media/facebook.442ab269.svg";